import React from 'react';
import { ReactComponent as IconComponent } from '@THC/assets/svgs/cross-circle.svg';
import { Icon } from '../Icon/Icon';
export const CrossCircleIcon = (props) => (<Icon {...props}>
		<IconComponent />
	</Icon>);
